"use strict";
/*
 * Created on 10 19 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * VendorAllowanceConverter
 *
 * @author JMe
 */


var VendorAllowanceConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(VendorAllowanceConverter, _DataObjectConverter_);

  function VendorAllowanceConverter() {
    _classCallCheck(this, VendorAllowanceConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(VendorAllowanceConverter).apply(this, arguments));
  }

  return VendorAllowanceConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.VendorAllowanceConverter = VendorAllowanceConverter;